import { ApiKeyVm } from './../classes/apiKeyVm';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';

export class ApiKeyApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async list(): Promise<ApiKeyVm[]> {
    const response: AxiosResponse<
      AppResponse<ApiKeyVm[]>
    > = await AuthorizedApiClient.get('/ApiKey/getapikeylist');
    const appResponse: AppResponse<ApiKeyVm[]> = response.data;
    if (appResponse.IsSuccess) {
      const apiKeys: ApiKeyVm[] = appResponse.Result ? appResponse.Result : [];
      return apiKeys;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async get(): Promise<ApiKeyVm> {
    const response: AxiosResponse<
      AppResponse<ApiKeyVm>
    > = await AuthorizedApiClient.get(`/ApiKey/GetApiKey?Id=${this.MasterAccountId}`);
    const appResponse: AppResponse<ApiKeyVm> = response.data;
    if (appResponse.IsSuccess) {
      const device: ApiKeyVm = appResponse.Result;
      return device;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async add(): Promise<string> {
    const response: AxiosResponse<
      AppResponse<string>
    > = await AuthorizedApiClient.post('/ApiKey/createapikey', {
      PermissionList: ['portal'],
    });
    const appResponse: AppResponse<string> = response.data;
    if (appResponse.IsSuccess) {
      return (appResponse.Result as string);
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async delete(KeyId: string): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.delete(`/ApiKey/DeleteApiKey?Id=${KeyId}`);
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
